import axios from 'axios';
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import DataTable from '../components/DataTable';

const ListarGuiasdeAprendizaje = ({ refresh }) => {
  const [guias, setGuias] = useState([]);
  const { codPrograma } = useParams();
  const navigate = useNavigate();

  const generarYDescargarGuia = async (idGuia, codPrograma, numeroGuia) => {
    try {
      console.log(`Generando descarga para guía número: ${numeroGuia}`);
      const response = await axios.get(`/api/guia-aprendizaje/generar-docx/${idGuia}`, {
        responseType: 'blob',
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `GuiaAprendizaje_${codPrograma}_N${numeroGuia}.docx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Error al generar la guía:', error.message);
      Swal.fire('Error', 'No se pudo generar la guía.', 'error');
    }
  };

  const getData = useCallback(async () => {
    try {
      const response = await axios.get(`/api/programas/guias/listidprograma/${codPrograma}`);

      if (response.data && response.data.ok && Array.isArray(response.data.guias)) {
        const guiasOrdenadas = response.data.guias
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

        const total = guiasOrdenadas.length;

        const guiasConFunciones = guiasOrdenadas.map((guia, index) => {
          const numeroGuia = total - index;

          return {
            ...guia,
            numeroGuia,
            funciones: (
              <div className="d-flex gap-2">
                <button
                  className="btn btn-warning"
                  style={{ width: "30px", height: "30px", padding: "0" }}
                  onClick={() => navigate(`/institucional/programas/guias/editar/${guia._id}`)}
                >
                  <i className="fa-solid fa-pen-to-square"></i>
                </button>

                <button
                  className="btn btn-success"
                  style={{ width: "30px", height: "30px", padding: "0" }}
                  onClick={() => generarYDescargarGuia(guia._id, guia.codPrograma, numeroGuia)}
                  title={`Descargar Guía N° ${numeroGuia}`}
                >
                  <i className="fa-solid fa-file-word fa-lg" style={{ color: "#ffffff" }}></i>
                </button>

                <button
                  className="btn btn-danger"
                  style={{ width: "30px", height: "30px", padding: "0" }}
                  onClick={() => deleteGuia(guia._id)}
                >
                  <i className="fa-solid fa-trash"></i>
                </button>
              </div>
            ),
          };
        });

        setGuias(guiasConFunciones);
      } else {
        setGuias([]);
      }
    } catch (error) {
      console.error('Error al cargar las guías:', error.message);
    }
    // eslint-disable-next-line
  }, [codPrograma, navigate]);

  useEffect(() => {
    if (codPrograma) getData();
  }, [codPrograma, getData, refresh]);

  const deleteGuia = async (idGuia) => {
    try {
      const confirm = await Swal.fire({
        title: '¿Está seguro?',
        text: '¡Esta acción no se puede deshacer!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, eliminar',
      });

      if (confirm.isConfirmed) {
        const { data } = await axios.delete(`/api/programas/guias/delete/${idGuia}`);
        setGuias(prevGuias => prevGuias.filter(guia => guia._id !== idGuia));
        Swal.fire({
          icon: 'success',
          title: data.message || 'Guía eliminada',
          showConfirmButton: false,
          timer: 1500,
        });
        getData();
      }
    } catch (error) {
      console.error('Error al eliminar la guía:', error.message);
      Swal.fire('Error', 'No se pudo eliminar la guía.', 'error');
    }
  };

  const columns = React.useMemo(() => [
    { Header: 'N° Guía', accessor: 'numeroGuia' },
    { Header: 'Programa', accessor: 'nombrePrograma' },
    { Header: 'Proyecto Formativo', accessor: 'nombreProyectoFormativo' },
    { Header: 'Fase', accessor: 'faseProyecto' },
    { accessor: 'funciones' },
  ], []);

  return (
    <div className="container-fluid py-1 px-0 shadow-lg rounded-4 bg-light mt-5">
       <div className="d-flex align-items-center mb-3">
        <button
          style={{ marginTop: '24px', marginLeft: '32px' }}
          className="btn btn-outline-dark rounded-pill shadow-sm px-3 d-flex align-items-center gap-2 me-3"
          onClick={() => navigate('/institucional/programas')}
          title="Regresar"
        >
          <i className="fa-solid fa-arrow-rotate-left"></i>
          <span>Volver</span>
        </button>

        <h1 className="text-center flex-grow-1 m-0">Lista de Guías de Aprendizaje</h1>
      </div>
      {guias.length > 0 ? (
        <DataTable columns={columns} data={guias} />
      ) : (
        <p className="text-muted">No hay guías disponibles para este programa.</p>
      )}
    </div>
  );
};

export default ListarGuiasdeAprendizaje;
